import {Component, OnInit} from '@angular/core';
import {
  ActivatedRoute,
  ActivationEnd,
  NavigationCancel,
  NavigationEnd, NavigationError,
  NavigationStart,
  Router,
  RouterEvent
} from '@angular/router';
import {filter} from 'rxjs/operators';


declare var $;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'rejestracje';
  loading = true;

  constructor(public router: Router) {
  }

  ngOnInit(): void {
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      }
      if (event instanceof NavigationEnd) {
        this.loading = false;
      }

      // Set loading state to false in both of the below events to hide the spinner in case a request fails
      if (event instanceof NavigationCancel) {
        this.loading = false;
      }
      if (event instanceof NavigationError) {
        this.loading = false;
      }
    });

    this.router.events.pipe(filter(evt => evt instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      let currentUrl = $('a.changeLang').attr('href');
      if (!currentUrl) {
        return;
      }
      currentUrl = new URL(currentUrl);
      currentUrl.hash = `#${event.url}`;
      $('a.changeLang').attr('href', currentUrl.href);
    });
  }
}
